import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import getQueryParam from 'src/app/utils/getQueryParam';
import { tutorStateAtom } from 'src/app/state/atoms';

/**
 * Hook to get payload related to conversation history from parent window and save into recoil
 */

function useConversationHistory() {
  const [_, setTutorState] = useRecoilState(tutorStateAtom);

  useEffect(() => {
    setTutorState((prev) => ({
      ...prev,
      isHistoryMode: getQueryParam('show_history') === 'true',
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useConversationHistory;
